export default {
  line: "Линија",
  language: "Језик",
  common: [
"Онлајн услуге",
"Откажи суспензију",
"Да ли да потрошим 10.000 ₽ да бих извршио куповину!"
  ],
  informationHub: "Званични хаб SGM.s",
  charitables:[//慈善
	  "Добродошли у званични информативни центар компаније SGM.s! 🌟 Ваша платформа за транспарентне и ауторитативне информације. Овде можете погледати наше званичне сертификате 📜, посетити https://sgm.lol/ за свеобухватне информације 🌐 и пратити наш Telegram канал за најновије информације! 📲 Поред тога, пронаћи ћете позитивне критике о SGM.s-у од међународних медија попут Yahoo-а, The Associated Press-а и Google-а! 📰 Све ово ће значајно повећати ваше поверење у бренд SGM.s и његов будући развој, помажући вам да успете у послу дељене мобилности и константно зарађујете значајан додатни приход.! 💰🚀"
	  ],
  details:[
"Јединична цена задатка", "Број поруџбине", "Дневни приход", "ниво", "Дневна добит", "Депозит", "Датум враћања депозита", "Преостали дани", "Мој SGM.s ниво"
  ],
  upload: [
"Отпремање...",
"Погрешан формат",
"Отпремљено успешно",
"Отпремање није успело"
  ],
  vanPull: [
 "Нема више података",
"Нема података"
  ],
  login: {
    title:'Пријавите се са корисничким именом и лозинком',
    title_txt:'Пријавите се користећи регистровани број мобилног телефона',
    text: [
"Запамти корисничко име/лозинку",
"Пријављивање...",
"Пријави се сада"
    ],
    placeholder: [
      "Молимо унесите број телефона",
"Молимо унесите лозинку за пријаву"
    ],
    i18n: [
      "Немате {title} налог? {a} {line}",
"Региструјте се"
    ],
    serve:[
      "Прихватите нашу „политику приватности“ или „услове коришћења сервера“"
    ]
  },
  register: {
    text: [
      "Добродошли на регистрацију",
"Слање СМС кода...",
"Преузми СМС код",
"Региструјем се...",
"Региструј се сада",
"Већ имате налог? Пријавите се сада",
"Регистрација броја мобилног телефона",
"Регистрација имејла",

"Назад на пријаву",
"Молимо вас да користите нерегистровани број телефона и имејл адресу"
    ],
    placeholder: [
      "Молимо вас да унесете свој број телефона",
"Молимо вас да унесете СМС верификациони код",
"Молимо вас да унесете лозинку за пријаву",
"Молимо вас да потврдите лозинку",
"Молимо вас да унесете позивни код",
"Две лозинке су различите",
"Молимо вас да унесете верификациони код",
"Молимо вас да унесете број е-поште",
"Не може почети са 0"
    ],
    i18n: [
      "Имате налог? {a} {line}",
"Пријавите се"
    ]
  },
  home: {
    lucky: "Догађај још није отворен",
    map: "Локација",
    qywh: "Корпоративна култура",
    broadcast: "Честитамо кориснику {member} што је позвао пријатеља да се придружи SGM.s програму за дељење бицикала на мрежи, што је унапређен у {vipname} и што је добио награде за дељење {grade}..",
    menu: [
      "ВИП зона",
"Видео туторијал",
"Награде за промоцију"
    ],
    taskHall: {
      title: [
        "Сала задатака",
"Пословна сала",
"Завршите задатке да бисте остварили профит"
      ]
    },
    title:['Задатак','Вести','више','откључај','Молимо вас да откључате и наставите да користите~','Проверите','Честитамо!Надоградња је успешна','Честитамо~ добио сам две карте за испуштање'],
    memberList: {
      title: "Списак чланова",
      data: [
        "{member},заврши данашње задатке поруџбине ({num})!"
      ]
    },
    businessList: {
      title: "Листа трговаца",
      data: [
        "{member}",
        "Објави {num} појединачни задатак данас"
      ]
    },
    noticeTitle: ["Обавештење", "Претходно", "Следеће"],
    tabBar: ["Кућа", "Достава", "Т", "Мапа", "Мој"],
    msg: "Задатак није отворен",
    video: "Нема видео туторијала",
	  message: "Имате нове вести",
	  bonus:[
		'<p>Унесите код да бисте добили новчану награду „Код за бициклизам“ (1-200000 TJS)</p><p>1. „Код за бициклизам“ се добија кроз активности компаније!</p><p>2. СГМ ће периодично објављивати лозинку! Молимо вас да свакодневно проверавате ажурирања!</p><p>Распоредите бицикле, уживајте у животу економије дељења и лако добијајте новчане награде у виду кода!</p><p>За детаље, обратите се „Менаџеру тржишта“</p>',
'Лозинка се добија кроз активности компаније!',
'Унесите код из црвене коверте',
'Добијте новац',
'Честитамо на освајању Ride Cash {износ}TJS',
'Ride Cash'
	],
    helpCenter: {
      title: "Help Center",
      empty: "No help articles"
    }
  },
  vip: {
    title:[
      "VIP ниво",
"Придружите се чланству сада да бисте преузели задатке",
"У развоју"
    ],
    user: {
      title: [
        "Ваш идентитет",
"Посетиоци"
      ],
      label: "Дневни задаци",
      value: [
        "Датум ступања на снагу",
"Једна година",
"Молимо вас да се прво пријавите",
"Период важења праксе",
"Одбројавање за повраћај депозита",
"Одбројавање за важење VIP нивоа"
      ],
    },
    list: {
      label: "Дневна поруџбина:{number}",
      button: "Придружи се сада",
      text: [
        "Дневни профит", "Месечни приход", "Награда за регрутовање: Сви", "Бесплатно", "По поруџбини", "Приход од оцене", "Ефективни повраћај", "Датум истека", "Година", "Дан", "Период важења"
      ],
    },
    dialog: [
      "Да ли сте сигурни да ћете потрошити {currency} {amount} да бисте постали {name}?",
"Тренутно сте {currname} и не можете бити {name}",
"Да ли сте сигурни да ћете потрошити {currency} {amount} да бисте обновили {name}?",
    ],
    index: ["Откажи", "Потврди"],
    desc: [
      '{level} Погодности',
'Основни приход',
'Време',
'Број испорука',
'Приход',
'Дневно',
'Месечно',
'Годишње',
'Приход од запошљавања',//8
'Ниво подређеног',
'Однос провизије за запошљавање',
'Бонус за запошљавање',
'Подрођени нивоа 1',
'Подрођени нивоа 2',
'Подрођени нивоа 3',
'Попуст за испоруку за један дан',
'Ниво подређеног',
'Однос поврата за испоруку подређеног',//17
'Износ поврата за испоруку',
'Подрођени нивоа 1',
'Подрођени нивоа 2',
'Подрођени нивоа 3',
'3 дана',
'Јединична цена испоруке',
'Детаљи пробног периода',//24
'Пробни период: Није потребна куповина. Користите дељене бицикле два пута дневно, уз провизију од 3 TJS по ангажовању, што укупно износи 6 TJS дневно. Бесплатни пробни период 2 дана.Пракса: Није потребна куповина, 2 пласмана дневно, провизија од 3 TJS по пласману, 6 TJS дневно. Бесплатна пробна верзија 2 дана',
'Пример провизије за задатак:',
'<p>Партнери нивоа 1 који дневно изврше поруџбине вожње у вредности од 10.000 TJS зарадиће провизију од 300 TJS.</p><p>Партнери нивоа 2 који дневно изврше поруџбине вожње у вредности од 10.000 TJS зарадиће провизију од 200 TJS.</p><p>Партнери нивоа 3 који дневно изврше поруџбине вожње у вредности од 10.000 TJS зарадиће провизију од 100 TJS.</p>',
'Опис бонуса за препоруку:',
      '<p>(Подређени нивоа 1) Директно позивате А да се придружи, А је ваш подређени нивоа 1.</p><p>(Подређени нивоа 2) А позива Б да се придружи, Б је ваш подређени нивоа 2.</p><p>(Подређени нивоа 3) Б позива Ц да се придружи, Ц је ваш подређени нивоа 3.</p><p>Напомена: Бонус за препоруку може се затражити само за највиши бонус тренутног нивоа појединца.</p>',
    ]
  },
  charitable:[
	  'Иницијатива за зелену филантропију',
	  'СГМ сматра филантропију и јавну добробит корпоративном мисијом. Редовно донирамо залихе и средства заједницама са ниским приходима, особама са инвалидитетом и школама, и сарађујемо са невладиним организацијама на зеленој мобилности и пројектима заштите животне средине.',
	  'Сваки бицикл који поделимо представља добротворну донацију, помажући градовима да смање емисије, а истовремено ширећи топлину.',
	  'Подржавамо дух „бициклизма, доброчинства и обостране користи“ и осветљавамо наду нашим точковима. Искрено вас позивамо да се придружите SGM.s-у, возите за зелену будућност и ширите љубав.',
	  'Подстичемо вас да активно учествујете у добротворним иницијативама заједнице и заједно дозволите да љубав и зеленило цветају у сваком кутку града.'
  ],
  lucky: {
  	default:[
  		"Срећна педала",
"Преостали број извлачења:",
"Запис о лутрији",
"Правила лутрије",
"<p>Учествујте у активностима компаније и искористите прилике за срећно извлачење!</p>",
"Запис о добитном кориснику",
['Честитамо:{member}','Освојите награде {profit}'],
"Честитамо,Освојите награде",
"затвори",
"Време за извлачење је искоришћено",
"Важи до"
  	],
    scattered:[
      'Број извлачења',
'Вожња',
'<p>1. Број извлачења се добија кроз активности компаније!</p><p>2. Свако извлачење троши 1 извлачење!</p><p>3. Након што освојите физичку награду, контактирајте менаџера за регрутацију да бисте регистровали своје податке и добили је!</p>',
'Подсетник',
'Важни подсетници',
'Право на извлачење',
'Добијте шансе за извлачење кроз активности компаније',
'Правила извлачења',
'1 извлачење троши се по покушају',
'Искоришћење награде',
'Контактирајте менаџера за регрутацију за физичке награде'
	  
    ],
	prizeList:[
		'Наградни фонд Lucky Pedal', '52 TJS у готовини', 'Тренутно повлачење', '88 TJS у готовини', '205 TJS у готовини', '19.889 TJS у готовини', '236.666 TJS у готовини', 'Андроид телефон', 'Вредност 8.000 TJS', 'Ваучер за надоградњу', 'Вредност 600 TJS', 'Двоструке поруџбине', 'Дневно', 'Ексклузивна преносна батерија компаније SGM', 'Вредност 1.000 TJS', 'Механички бицикл', 'Вредност 3.000 TJS', 'Електрични мотопед', 'Вредност 80.000 TJS', 'Ајфон 17', 'Вредност 160.000 TJS'
	],
  },
  moments:[
	  'Дневна ажурирања',
	  'Званична платформа за запослене у SGM.s-у за дељење зараде од распоређивања бицикала, добротворних активности и дивних тренутака. Ажурирајте свакодневно 3 узастопна дана да бисте учествовали у извлачењу новчаних награда (1-200.000 TJS). Придружите се саиграчима у ширењу љубави и чињењу сваке вожње вреднијом!'
  ],
  userLc:{
  	default:[
  	"Cycling Wealth",
"Записи",

"Износ",

"Период складиштења",

"Износ депозита",

"Молимо вас да унесете износ депозита",

"Приход",

"Пошаљи",


"Прво изаберите производ",

"Молимо вас да изаберете информације",

"Профит",

"Дан",

"нема података",

"Време куповине",

"држава",

"Време завршетка",

"Стање",

"Данашња зарада",
"Куповина једним кликом"//18
  	],
    tabs: [
      "Листа производа",
"Евиденција уштеде"
     ],
    tips:'<p>VOISP „Wealth Enhance“ је начин компаније да свим запосленима на М нивоу пружи више начина за повећање прихода. Инвестициони пројекти су финансијски инвестициони пројекти које заједнички покрећу PAGE, банке, компаније за управљање имовином итд.!</p><p>Краткорочна инвестиција: стабилан приход, флексибилан избор циклуса! Краткорочна неактивна средства могу донети додатни приход кроз улагање!Дугорочна инвестиција: Већи приноси, неговање добре редовне инвестиционе штедње, већи приноси и остваривање својих снова кроз акумулацију!</p>'
  },
  newlist: {
    text: [
     "Нема записа", "Очекивани приход", "резултати", "купи време", "статус", "Крај времена"
    ],
    placeholder: [
     "нема више података",
"нема података"
    ],
    i18n: [
     "Историја куповине",
    ],
	title:[
		"План зелене штедње Cycling Wealth — Посебна погодност дизајнирана искључиво за запослене са пуним радним временом у SGM.s-у!",
		"Ваша средства надгледају и одобравају финансијске институције као што су штедионице, и 100% су безбедна и поуздана. СГМ сарађује са многим водећим банкама како би пружио широк спектар производа за штедњу са флексибилним условима и разноврсним приносима како би се испунили ваши финансијски циљеви у свим фазама.",
"Не само да вас подстичемо да активно учествујете у примени бицикала и прихватите путовања са ниском емисијом угљеника, већ се надамо и да ћете мудро планирати своје личне финансије док доприносите зеленијој будућности. СГМ је поносан што хода уз вас док заједно отварамо ново поглавље у зеленом богатству!"
	]
  },
  product: {
    default: [
      "Стање на промотивном рачуну",
"Почетни износ уштеде",
"Максимални износ уштеде",
"Циклус",
"Дневна каматна стопа",
"максимално",
"Правила пројекта",
"Износ пројекта",
"Начин плаћања",
"Почетни износ уштеде",
"Дневна добит",

"Циклус отплате",
"Процењени приход"
    ],
    investRange: "Опсег износа улагања",
    placeholder: [
      "Врати главницу и приход по доспећу (нормално за празнике)",
", аутоматско поравнање у року од 24 сата",
"{str} = укупан приход {income} {currency} + главница {money} {currency} = укупна главница и камата {total} {currency}",
"Безбедносна лозинка"
    ]
  },
  user: {
    vipl:"Ниво партнера",
    hello:"Добродошао назад",
    default: [
      "Мој надређени", "Рачун", "Код позивнице", "Излаз из пријаве", "Стање", "Злато", "Мој новчаник", "Печат", "Ограничење", "Добро", "Одлично", "Активирај 'Асистента за читање'", "Контактирај менаџера за запошљавање", "Оперативни трошкови"
    ],
    myEarnings: {
            grid: ["Стање", "Јучерашња зарада", "Данашња зарада", "Зарада ове недеље", "Зарада овог месеца", "Зарада прошлог месеца", "Укупан приход", "Заврши задатак данас (PCE)", "Преостали задаци данас (PCE)", "Данашња провизија", "Попуст за испоруку", "Попуст за препоруку"]
        },
    grid: [
      "Стање", "Јучерашња зарада", "Данашња зарада", "Зарада ове недеље", "Зарада овог месеца", "Зарада прошлог месеца", "Укупан приход", "Завршите задатак данас (PCE)", "Преостали задаци данас (PCE)", "Данашња провизија", "Данашњи попуст"
    ],
    menu: [
      "Записи задатака",
"Ревизорски задатак",
"Управљање објављивањем",
"Лични подаци",//3
"Повезивање налога",
"Дневни извод",
"Рачуноводствени записи",//6
"Дељени позив",
"Извештаји тима",//8
"Приручник за помоћ",//9
"Кредитни резултат",//10
"Преузмите апликацију",//11
"Срећна педала",//12
"Богатство бициклом",
"Асистент за читање",
"Корпоративна култура",
"Видео упутства",
"Одличан тим",
"Богатство бициклом",
"Пратите SGM.s",
"Награде за раст",
"Кодекс за бициклизам",
"Педала за дела"
    ],
	positions:[
		"Моја позиција",
"Тренутна позиција",
"Следећа позиција",
"Директно повезани члан М нивоа",
"Члан тима М нивоа 3",
"Тим нивоа 3 (број {post})",
"Испуните све услове да бисте контактирали менаџера за запошљавање ради унапређења ваше позиције!",
"Опис позиције",
"Пријавите се за позицију",
"Информације о позицији"
	],
	office:[
		"Информације о мом послу",
"Детаљи о унапређењу на послу",
"Опис посла SGM.s",
"Позиција у корпорацији",
"Унапређење на послу",
"примити",
"Напредак унапређења",
"Најмање ",
"Услови нису испуњени",//8
"Директни подређени морају продати {num} бицикала.",
"Чланови тима морају продати {num} бицикала.",
" чланова",
"Примљено"//12
	],
	current:[
		"Тренутне позиције",
"Укупан број VIP чланова"
	],
	subordinate:[
		"1. ниво", "2. ниво", "3. ниво", "листа чланова", "укупан број људи", "Укупан приход", "Износ повлачења", "Приход тима", "Листа чланова", "корисник", "ниво", "Време придруживања", "Пробни период"
	],
	follow:[
		"Званични канал СГМ-а",
"Пратите канал да бисте сазнали више о најновијим информацијама о СГМ-у!"
	]
  },
  userInfo: {
    default: [
      "Лични подаци",
"Портрет главе",
"Број мобилног телефона",
"Додај банковни рачун",
"Alipay",
"Право име",

"Лозинка за пријаву",

"Лозинка за фонд",

"Кликни на Подешавања",
"Промени портрет главе",

"Промени лозинку за пријаву",

"Промени лозинку за фонд",

"Пошаљи",
"Испразни кеш меморију",
"Одјави се"
    ],
    label: [
      "Оригинална лозинка за пријаву",
"Нова лозинка за пријаву",
"Потврђивање лозинки",
"Оригинални код за новац",
"Нови код за новац",
"Потврдите лозинку"
    ],
    placeholder: [
      "Молимо вас да унесете оригиналну лозинку за пријаву",
"Молимо вас да унесете нову лозинку за пријаву",
"Молимо вас да потврдите лозинку за пријаву",
"Молимо вас да унесете оригиналну лозинку фонда",
"Молимо вас да унесете нову лозинку фонда",
"Молимо вас да потврдите лозинку фонда"
    ]
  },
  userSet: {
    default: [
      "Сертификација правог имена",
"Детаљне информације",
"Вежи Alipay",
"Пошаљи"
    ],
    label: [
      "Право име",
"QQ",
"Alipay налог",
"Alipay име"
    ],
    placeholder: [
      "Молимо вас да унесете право име (моје име се користи за подизање готовине)",
"Унесите QQ број",
"Молимо вас да унесете Alipay налог",
"Молимо вас да унесете Alipay име"
    ],
    tips: "Подсетник: Повезана банковна картица се не може модификовати, она се користи за ваше повлачење новца"
  },
  bindAccount: {
    default: [
      "Повежи налог",
"Погледај туторијал",
"Пошаљи"
    ],
    tabs: [
      "Налог",
"Налог",
"Налог"
    ],
    label: [
      "Упутства",
"Додај снимак екрана",
"Налог"
    ],
    placeholder: "Молимо вас да унесете свој {account} налог"
  },
  bankCard: {
    default: [
      "Повежи банковну картицу",
"Аутентификуј сада",
"Слање ...",
"Додај сада",
"Додај банковну картицу"
    ],
    tips: [
      "Молимо вас да завршите аутентификацију правим именом пре него што додате банковну картицу",
      "Име на вашем рачуну на банковној картици мора бити иста као и право име које сте аутентификовали, у супротном нећете моћи успешно да подигнете новац.."
    ],
    label: [
      "Име",
"Назив банке",
"Број банковног рачуна",
"Шифра филијале",
"IFSC"
    ],
    placeholder: [
      "Молимо изаберите назив банке",
"Молимо унесите број банковног рачуна",
"Молимо унесите код филијале",
"Потврди",
"Откажи",
"Молимо унесите IFSC"
    ]
  },
  wallet: {
    default: [
      "Мој новчаник", "Допуна", "Повлачење", "Евиденција допуна", "Евиденција повлачења", "R", "W",
"₽ допуна"
    ],
    label: [
      "Начин повлачења",
"Износ повлачења",
"Лозинка фонда",
"Пошаљи",
"Број телефона",
"Имејл",
"IFSC",
"Начин плаћања",
"Порез",
"Стварно примљени износ"
    ],
    placeholder: [
      "Изаберите начин исплате",
"Молимо вас да унесете износ исплате",
"Молимо вас да унесете лозинку за фонд",
"Молимо вас да изаберете начин исплате",
"Молимо вас да унесете број мобилног телефона примаоца",
"Молимо вас да унесете адресу е-поште примаоца",
"Молимо вас да унесете IFSC примаоца",
"Молимо вас да изаберете начин плаћања"
    ],
    msg: [
      "Још нисте поставили лозинку за фонд, прво је поставите",
"Још нисте повезали своју банковну картицу, прво је повежите",
"<p>Време исплате:</p><p>Понедељак: M9</p><p>Уторак: M8</p><p>Среда: M6/M7</p><p>Четвртак: M3/M4/M5</p><p>Петак: M1/M2</p><p>(Приправници од понедељка до недеље)</p><p>од 9 до 18 часова</p>"
    ]
  },
  recharge: {
    default: [
      "Допуна",
"Детаљи допуне",
"Запис о допуни",
"Расположиво стање {money}, изаберите начин допуне",
"Минимални износ је {currency} {min}, максимални {currency} {max}, накнада за обраду {fee}%",
"Слање...",
"Допуна сада",
"Враћање",
"Учитавање...",
"Минимални износ је ${min}, максимални ${max}, накнада за обраду {fee}%"
    ],
    label: [
      "Износ допуне",
"Канал допуне",
"Назив трансфера",
"Име платиоца",
"Мобилни телефон платиоца",
"УПИ рачун платиоца",
"Е-пошта платиоца",
"Налог трансакције"
    ],
    placeholder: [
      "Молимо вас да унесете износ допуне",
"Молимо вас да изаберете канал допуне",
"Молимо вас да унесете назив трансфера",
"Појединачни минимални износ је {currency} {min}",
"Појединачни максимални износ је {currency} {max}",
"Молимо вас да унесете име платиоца",
"Молимо вас да унесете број мобилног телефона платиоца",
"Молимо вас да унесете UPI налог платиоца",
"Молимо вас да унесете имејл адресу платиоца",
"Молимо вас да отпремите снимак екрана трансфера",
"Молимо вас да унесете број налога за трансакцију"
    ],
    info: [
      "Износ допуне", "Број поруџбине", "Банка", "Број рачуна", "Име", "Копија", "{type} Трансфер", "Снимак екрана трансфера", "Пошаљи", "IFSC код", "Тип рачуна", "Упутства за обраду"
    ],
    tips: [
      "Молимо вас да изаберете следећи метод за пренос одговарајућег износа како бисте избегли кашњење у финансијској провери.<br>Након трансфера, отпремите снимак екрана трансфера као потврду о верификацији",
"Нема потребе да додајете пријатеље, скенирајте QR код да бисте ми пребацили новац",
"Молимо вас да извршите трансфер према информацијама испод",
"Савет: Након успешне уплате, контактирајте онлајн службу да бисте навели број вашег чланског рачуна, износ допуне, број поруџбине, број рачуна депонента, време допуне, како би финансијско одељење могло благовремено да вам дода средства",
"Напомена: молимо вас да извршите једну уплату за сваки трансфер",
"Након трансфера, отпремите снимак екрана трансфера као потврду о верификацији",
"Савет: Након што је уплата успешна, отпремите слику успешне трансакције",
"<p>Подсетник за допуну: Молимо вас да прочитате пре допуне.</p><p>1: Молимо вас да платите према најновијем рачуну за допуну.</p><p>2: Рок важења уплате је 10 минута. Молимо вас да извршите уплату у року од 10 минута. Ако се уплата не изврши у року од 10 минута, рачун примаоца ће бити неважећи. Молимо вас да поново прибавите најновији рачун за допуну ради плаћања.</p><p>3: Износ трансфера мора бити у складу са износом који сте послали.</p><p>4: Ако плаћање не успе, молимо вас да не чувате претходни рачун примаоца. Молимо вас да поново пошаљете налог за допуну да бисте добили најновији рачун, у супротном ће се ваше плаћање сматрати неважећим.</p><p>5: Ако је плаћање успешно, молимо вас да пошаљете Ваучер за плаћање како је прописано како би се олакшала благовремена верификација од стране финансијског одељења.</p>"
    ],
    minPayHint: "Аз {min} TJS камтар пардохт намудан мумкин нест"
  },
  postTask:[
	  "наслов",
"Изаберите слику",
"Испоручите",
"Унесите наслов задатка"
  ],
  task: {
    default: [
      "Листа испорука", "Захтеви задатка", "Креирај", "Ревизија", "Отвори линк", "Копирај линк", "Јединична цена", "Пошаљи", "Одустајање", "Почни са приказивањем", "У току", "ПОЧНИ РАСПРЕМЕШТАВАЊЕ "
    ],
    tabs: [
      "Радим", "Ревизија", "Завршено", "Неуспешно", "Злонамерно", "Напуштено"
    ],
    msg: "Данашња мисија је завршена",
    msgSc: "Успешно примљено",
    msgTime: "Након завршетка одбројавања, задатак ће бити аутоматски завршен и његово прерано затварање неће бити важеће!",
    info: [
      "Детаљи задатка",
"Наслов задатка",
"Предности задатка",
"Опис задатка",
"Захтеви за отпремање",
"Пошаљи узорак",
"Корисник није послао узорак",
"Белешке о ревизији",
"Датум ревизије",
"Страна потражње",
"Објави",

"Копирај",

"Скочи",

"Кораци задатка",
"Корак {index}",

"Узорак ревизије",

"Нема узорка ревизије",
"Учитавање података...",
"Одустани од задатка",

"Пошаљи завршен задатак",
"Објави садржај"
    ],
    index: [
      "Тренутни статус",
"Ваша тренутна оцена је <i style=\"color:#1989fa\">{currVip}</i><br>можете преузети само тренутни <i style=\"color:#1989fa\">{currVip}</i> ниво задатка<br>да ли желите да се придружите <i style=\"color:#dd6161\">{vip}</i> нивоу",
"Придружите се сада",
"Молимо вас да изаберете категорију задатка",
"Откажи",
"Преостало",
"Бесплатна достава",
"Пратите нас"
    ],
    list: [
      "Листа задатака",
"Потражња",
"Преостало",
"Захтев",
"Пријем"
    ],
    show: [
      "Детаљи задатка", "Време куповине", "Статус испоруке", "Цена изнајмљивања", "Време испоруке", "Одбројавање до пријема", "Почетак сервирања", "Кодирање", "UNKONE"
    ]
  },
  postRecord: [
"Дневна ажурирања", "Објављивање", "Укупно", "Завршено", "Рок", "Ревизија", "Одустајање", "Уредници", "Дневна ажурирања", "Пријем", "Центар за обавештења SGM.s", "Информативни центар"
  ],
  dayReport: [
"Дневни извод", "Укупан приход", "Моја провизија", "Моје погодности од провизије", "Испорука коју су завршили подређени", "Погодности за задатак подређеног", "PCE", "Последњих 30 дана", "Количина", "Испорука", "Подрођени", "Потрошња", "Датум"
  ],
  fundRecord: {
    default: [
"Евиденција расхода",
"Евиденција допуне",
"Евиденција прихода",
"Р",
"И",

"Е",
"Евиденција повлачења",
    ],
    tabs: [
"Приход", "Расход", "Допуна", "Повлачење"
    ],
	state: [
'Све',
'Допуна', //1 recharge
'Повлачење', //2 withdrawal
'Објави задатак', //3 task
'Платна пумпа', //4 pump
'Повратак', //5 rebate
'Испорука завршена', //6 commission
'Награде за активност', //7 regment
'Награде за препоруку', //8 spread
'Надоградња', //9 buymembers
'Откажи задатак', //10 revoke
'Приход од инвестиција', //11 transfer_c
'Пренос у инвестицију', //12 transfer_r
'Остали приходи', //13 其他
'Донирај', //14
'Црвена коверта', //15
'Купи паметне роботе', //16
'Срећна педала', //17
'Повраћај ВИП куповине', //18
	]
  },
  promote: [
    "Твој најбољи пријатељ",
"Позивам те да се придружиш {title}",
"Код препоруке",
"Копирај код препоруке",
"Копирај линк позивнице",
"Сачувај QR код",
"Промотивни подстицаји",
"Успешно сачувај постер",//7
"Чување постера није успело, покушај још неколико пута или сачувај снимак екрана",
"Молимо те, направи снимак екрана",
"Сачувај промотивни постер",
"Сачувај промотивни постер на телефон<br>Ако не успеш, покушај још неколико пута или сачувај снимак екрана",
"Само званични SGM.s партнери имају право да позову пријатеље да се придруже!",
"Дељено путовање",
    '<p>1. Награде за дељење: Зарадите награде за дељење позивањем нових корисника да се придруже SGM.s-у.</p><p>2. Провизије од продаје: Зарадите дневне провизије од продаје дељених бицикала.</p><p>3. Активности компаније: Компанија редовно покреће разне промотивне активности, укључујући "Срећне педале", "Лозинке за вожњу" и физичке награде.</p><p>4. Кумулативне награде: Помозите компанији да прода и изнајми више дељених бицикала како би добила одређене новчане награде на почетној страници SGM.s-а. Што више дељених бицикала позовете на изнајмљивање, награда је већа.</p><p>5. Позиције у компанији: Када поседујете одређени број дељених бицикала, можете се пријавити за продајну позицију у компанији, као што су позиције нивоа 1, нивоа 2, нивоа 3 и менаџерске маркетиншке позиције, и добијати додатну месечну плату.</p><p>Сваки распоређени бицикл представља корак ка финансијској слободи; свака вожња доприноси смањењу емисија у градским условима. SGM.s вам помаже да постигнете финансијску слободу док прихватате зелени начин живота.</p>',
    "Дељење тимског путовања"
  ],
  teamReport: {
    default: [
"Претрага", "Стање тима", "Погодности за тим", "Допуна тима", "Исплата тима", "Број првих уплата", "Број првих гурања", "Величина тима", "Нови тим", "PCE", "Ја", "Корисник", "Допуна", "Исплате", "Поврат", "Провизија", "Изаберите датум", "Нема података", "Износ исплата", "Број исплата", "Поврат исплата", "Број исплата",//21
"Тимски партнер",
"Препоручени укупни приход",
"Укупан приход од попуста за испоруку",
"Укупно повлачења тима нивоа 3",
"Оцена",
"Родитељ",
"Позвани",
"Листа корисника",
"Укупан број корисника"
    ],
    tabs: [
      "Извештаји тима",
"Мој тим"
    ],
    team: [
      "Ниво 1",
"Ниво 2",
"Ниво 3"
    ]
  },
  help: [
    "Приручник за помоћ",
"Није доступно"
  ],
  message:[
	  "Погледајте поруку",
"Нема поруке"
  ],
  credit: [
    "Кредитни резултат",
"Кредитна напомена",
"Кредитни записи",
"<p>Почетни кредитни резултат је 60 поена.</p><p>1: Ако је број поена мањи од 50, дневна количина испоруке ће бити преполовљена.</p><p>2: Резултат је мањи од 30 поена и дневни рад на испоруци не може бити завршен.</p><p>3: Ако је резултат мањи од 10 поена, не можете се пријавити за подизање готовине.</p><p>Правила награђивања поенима: Надоградња нивоа рада ће додати 5 поена, а позив подређенима да постану (формални запослени) ће додати 1 поен.</p><p>Негативан став према раду, неблаговремено завршетак испоруке и кршење прописа компаније утицаће на кредитни резултат.</p>",
"Мој кредит",
"Тренутно нема кредитног записа"
  ],
  dialog: [
    "Савети",
"Потврди",
"Слање...",
"Копирање је успешно",
"Верзија iOS система је ниска и није подржана",
"Регистрација...",
"Учитавање података..."
  ],
  lineList: [
    "Избор линије",
"Тренутна линија",
"Линија"
  ],
  serviceCenter: [
"Служба за кориснике",
"Здраво, ексклузивна служба за кориснике",
"Драго нам је да вам услужимо.",
"Самопослуживање",
"Онлајн служба за кориснике",
"Служба за допуну рачуна",
"Линејска служба за кориснике"
  ],
  direct:[
  	  'СГМ',
'Бонус за раст',
'Опис активности',
'<p>Након што директно позовете чланове да се придруже ВИП нивоу, можете добити новчане награде ако испуњавате услове!</p><p>На пример: ако кумулативно позовете 3 члана ВИП нивоа, можете директно добити награду. Након што је примите, наставите да остварујете друге циљеве и наставите да је примате.</p><p>Ексклузивна награда за раст СГМ-а, сваку награду сваки запослени може добити само једном.</p>',
'Број подређених',
'Треба завршити',
'Погодности позива',
'Примање награда',
'Примљено'
  ],
  activity:[
    'Педала за донације', 'Детаљи', 'Донација', 'Стање на рачуну', 'Све', 'Плаћање', 'Молимо вас да унесете износ донације', 'Хвала вам на донацији'
  ],
  apply: {
    awardsTitle: "Nagrade",
    awardsContent: "Nagrade",
    pickUpVehicles: "Покупи {count} возила"
  },
  positions:{
    info:['Детаљи позиције', 'Пријава за позицију', 'Позиција', 'Редовни запослени тима нивоа 3, ниво Г', 'Однос чланова тима трећег нивоа', 'Плата за овај месец', 'Обрачун плате', 'Завршено', 'Треба да се заврши', 'Примљено', 'Време наплате плате'],
    job: ['Submit for review','Under review','Reviewed','Please upload your relevant documents','Comments','Click on the picture to select and upload your ID photo. ','Please upload a photo of the front of your ID card in Photo A. ','Please upload a photo of the back of your ID card in Photo B. ','Please upload a photo of yourself holding your ID card in Photo C. ','Photo A','Photo B','Photo C','Please select the position you want to be promoted to','Position','Basic salary','Additional bonus','Notice To Employees','I have read and agreed to the contents of the 《Position Application Guidelines》','Submit Position application',"Please select a position","Please select Photo A","Please select Photo B","Please select Photo C"]
  },
}